function getEventName(channelName, eventName) {
  return `${channelName}_${eventName}`;
}

class Channel {
  constructor(name) {
    this.name = name;
  }

  trigger(eventName) {
    document.dispatchEvent(new CustomEvent(getEventName(this.name, eventName), { bubbles: false }));
  }

  on(eventName, eventHandler) {
    document.addEventListener(getEventName(this.name, eventName), eventHandler);
  }
}

const channels = {

};

export default {
  /*
        return an Object {
            trigger(){},
            on(){}
        }
    */
  channel(name) {
    if (!channels[name]) {
      channels[name] = new Channel(name);
    }

    return channels[name];
  },
};
